var log = Math.log;

// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
module.exports = Math.log1p || function log1p(x) {
  var n = +x;
  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/math-log1p.js
// module id = 1033
// module chunks = 0